import React from 'react';
import './OTOPage.css';

const OTOPage = () => {
  return (
    <main className="oto-page">
      <div className="oto-container">
        {/* Logo */}
        <header className="oto-header">
          <img 
            src="https://tagmango.com/assets/logo-2-v2-2adfd939849d39ad979dcdd84e2dd375.png" 
            alt="John S Tamang Logo" 
            className="oto-logo" 
          />
        </header>
        
        {/* Main Content Section */}
        <section className="oto-content">
          <div className="oto-split">
            {/* Left: Copy */}
            <article className="oto-copy">
              <p className="oto-eyebrow">YOUR ₹97 BLUEPRINT KIT PURCHASE IS CONFIRMED</p>
              
              <h1 className="oto-headline">
                You've Got the Blueprint. Now Discover What <strong>YOUR</strong> Retail Business Really Needs to <span className="highlight">Fix First</span>.
              </h1>
              
              <p className="oto-problem">
                Sales, staff, stock, profits—when everything needs your attention, it's easy to spend your days fixing symptoms instead of solving the real problem.
              </p>
              
              <p className="oto-question">
                <strong>What if just ONE focused conversation could help you see which THREE priorities deserve your attention first?</strong>
              </p>
              
              <div className="oto-offer-strip">
                <h2 className="oto-offer-title">RETAIL CONTROL CLARITY AUDIT CALL™</h2>
                <p className="oto-offer-subtitle">60–90 Minutes • Personal 1-to-1 With John S Tamang • Focused on YOUR Business</p>
              </div>
              
              <div className="oto-benefits">
                <div className="oto-benefit">
                  <h3>01 — FIND THE REAL PROBLEM</h3>
                  <p>A focused pre-call diagnostic built around your biggest retail challenge.</p>
                </div>
                <div className="oto-benefit">
                  <h3>02 — UNDERSTAND THE ROOT CAUSE</h3>
                  <p>Discuss your SWOTC findings and discover what may be holding your business back.</p>
                </div>
                <div className="oto-benefit">
                  <h3>03 — KNOW YOUR POWER OF THREE™</h3>
                  <p>Identify the three most important priorities to tackle first.</p>
                </div>
                <div className="oto-benefit">
                  <h3>04 — SEE YOUR 180-DAY ROADMAP</h3>
                  <p>Walk through a personalised plan for the next six months.</p>
                </div>
              </div>
              
              <div className="oto-bonus">
                <p>🎁 <strong>COMPLIMENTARY BONUS — Mastering Retail Operations eBook</strong></p>
                <p className="oto-bonus-subtitle">Practical checklists, SOPs and tools to support implementation.</p>
              </div>
              
              {/* Price & CTA */}
              <div className="oto-action">
                <p className="oto-decision-message">
                  For retail owners serious about building a more profitable, sustainable and scalable business—without having to make every decision themselves.
                </p>
                
                <div className="oto-pricing">
                  <h2 className="oto-price-title">SPECIAL POST-PURCHASE UPGRADE — ₹499</h2>
                  <p className="oto-price-disclaimer">Applicable taxes or checkout charges, if any, are displayed before payment.</p>
                </div>
                
                <a 
                  href="https://academy.johnstamang.com/web/checkout/6aea4cf90a97ef717f3f762e" 
                  className="oto-btn-primary" 
                  data-testid="yes-upgrade-button"
                >
                  YES! HELP ME DISCOVER WHAT TO FIX FIRST — ₹499
                </a>
                
                <a 
                  href="https://academy.johnstamang.com/web/checkout/6ae7d300a307d6636a4deedd" 
                  className="oto-btn-secondary" 
                  data-testid="no-thanks-link"
                >
                  No thanks. I'll continue with my ₹97 Blueprint Kit.
                </a>
                
                <p className="oto-reassurance">
                  Your ₹97 Blueprint Kit is already yours. This personal audit helps you move from a general framework to focused guidance for your own business.
                </p>
              </div>
            </article>
            
            {/* Right: Portrait */}
            <aside className="oto-portrait">
              <img 
                src="https://tagmango.com/assets/my-picture-2-11c5b74df541cd5c74e892d4651afd2d.JPG" 
                alt="John S Tamang — Retail Business Consultant" 
                className="oto-image" 
              />
            </aside>
          </div>
        </section>
      </div>
    </main>
  );
};

export default OTOPage;